import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

/**
 * DELETE `/crm/sales-order/{id}`。
 * PREPARING／SHIPPING 軟取消 alias（→ CANCELLED）；**無** body。
 */
export async function deleteSalesOrder(id) {
  const { data: raw } = await request.delete(`/crm/sales-order/${id}`);
  return parseVer4DetailResponse(raw ?? {});
}
